import React, { FC } from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { HeaderIconContainer, LinkNoDecoration } from 'components/app-header/mobile-header/styled';
import { VisuallyHidden } from 'components/ucl/visually-hidden';
import { useNavigation } from 'hooks/navigation/use-navigation';
import { portalToHeader } from 'state/mobile-header-nav';
import { theme } from 'styles/configure-theme';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

export const StyledBackIcon = Icon.withConfig({
  color: theme.token('icon-header-contrast'),
  size: '5',
  ...hiddenAccessibilityPlatformProps,
});

interface BackArrowLinkProps {
  to: string;
}
const PortalBackArrowLink: React.VFC<BackArrowLinkProps> = portalToHeader(({ to }) => {
  const { formatMessage } = useIntl();

  return (
    <LinkNoDecoration to={to}>
      <StyledBackIcon variant="back" />
      <VisuallyHidden accessibilityLabel={formatMessage({ id: 'back' })} />
    </LinkNoDecoration>
  );
});
export const BackArrowLink: React.VFC<BackArrowLinkProps> = props => {
  return <PortalBackArrowLink {...props} />;
};

interface BackArrowHistoryProps {
  onPress?: () => void;
  icon?: React.ReactNode;
}

export const BackArrowHistoryButton: FC<BackArrowHistoryProps> = ({
  onPress,
  icon = <StyledBackIcon variant="back" />,
}) => {
  const { formatMessage } = useIntl();
  const { goBack } = useNavigation();
  const onPressBack = () => goBack();

  return (
    <HeaderIconContainer
      testID="back-arrow-history"
      onPress={onPress || onPressBack}
      accessibilityRole="button"
      accessibilityLabel={formatMessage({ id: 'back' })}
    >
      {icon}
      <VisuallyHidden accessibilityLabel={formatMessage({ id: 'back' })} />
    </HeaderIconContainer>
  );
};

export const PortalBackArrowHistory: React.VFC<BackArrowHistoryProps> = portalToHeader(
  BackArrowHistoryButton
);

export const BackArrowHistory: React.VFC<BackArrowHistoryProps> = props => {
  return <PortalBackArrowHistory {...props} />;
};
